(function($){
  module.exports = {
    success: function (message, delay, icon) { generic(message, 'success', icon, delay) },
    information: function (message, delay, icon) { generic(message, 'info', icon, delay) },
    error: function (message, delay, icon) { generic(message, 'danger', icon, delay) },
  };

  var generic = function(message, type, icon, delay) {
    $('body').pushAlert({
      text : message,
      type : type,
      icon : icon || 'bell',
      delay: (delay || delay === 0) ? delay : 10000
    });
  };
})(jQuery);



// WEBPACK FOOTER //
// ./src/modules-es5/commons/lib/lib-alert.js